import { Divider, Stack } from "@mui/material";
import ButtonPreview, { ButtonStyle } from "./ButtonPreview";
import NavigationPreview from "./NavigationPreview";
import OnboardingPreview from "./OnboardingPreview";
import ShortcutsPreview from "./ShortcutsPreview";
import { ComponentColors } from "./types";

type PaletteComponentsPreviewsProps = {
  selectedPalette: ComponentColors;
  buttonStyle: ButtonStyle;
};

const PaletteComponentsPreviews = ({
  selectedPalette,
  buttonStyle,
}: PaletteComponentsPreviewsProps) => {
  return (
    <Stack
      direction="column"
      spacing={1}
      bgcolor={selectedPalette.backgrounds.background1}
      borderRadius={1}
      border={`1px solid #000`}
      p={1}
    >
      <NavigationPreview
        navBarPalette={selectedPalette.navBar}
        badgePalette={selectedPalette.badge}
      />
      <Divider />
      <ShortcutsPreview selectedPalette={selectedPalette.shortcuts} />
      <Divider />
      <ButtonPreview
        selectedPalette={selectedPalette.button}
        buttonStyle={buttonStyle}
      />
      <Divider />
      <OnboardingPreview selectedPalette={selectedPalette.onboarding} />
    </Stack>
  );
};

export default PaletteComponentsPreviews;
